<template>
  <div class="page-404">
    <div class="wrap">
      <img v-if="theme === 'black'" src="/images/404-logo.png">
      <img v-else src="/images/404-logo-light.png">
      <h6>您访问的页面不存在，可能有以下原因</h6>
      <div class="reason">
        <p>1. 页面本身不存在</p>
        <p>2. 程序签名错误</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404',
  data () {
    return {
      theme: window.theme
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/style/variables";
@import "../assets/style/themeify";
@include themeify {
  .page-404 {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .wrap {
      width: 400px;
      height: 300px;
      text-align: center;
      color: themed('font-color');
      letter-spacing: 1px;
      h6 {
        font-size: 18px;
      }
      .reason {
        font-size: 14px;
        text-align: left;
        padding: 16px;
        background-color: themed('background-color');
        margin-top: 16px;
        color: themed('font-color');
        line-height: 24px;
      }
    }
    img {
      width: 200px;
    }
    .opera {
      margin-top: 30px;
      a {
        display: inline-block;
        padding: 8px 30px;
        color: #f7f7f7;
        font-size: 14px;
        background-color: $primary-color;
        border-radius: 20px;
        transition: all ease .3s;
        &:hover {
          background-color: $primary-color - 10;
        }
      }
    }
  }
}
</style>
